import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PieceStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('PieceStatusReference');
  }
}
